import { render, staticRenderFns } from "./Regist.vue?vue&type=template&id=68803814&"
import script from "./Regist.vue?vue&type=script&lang=js&"
export * from "./Regist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports